import {get, post} from '~/utils/request';

export function getProductInfo(data) {
  return post('/MallCenter/ProductInfo', data);
}

export function createOrder(data) {
  return post('/MallCenter/CreateOrder', data);
}

export function payOrder(data){
  return post('/Order/Pay', data);
}

export function checkPaidState(data){
  return post('/Order/CheckPaidState', data);
}
